/**
 * AI Layer search results — added/removed by AILayerSearchModal, consumed by LayerPanel + map.
 */
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export interface AiLayer {
  id: string;
  name: string;
  source: string;
  url: string;
  description: string;
  format: string;
  color: string;
  visible: boolean;
}

interface AiLayersStore {
  layers: AiLayer[];
  add: (l: Omit<AiLayer, 'id' | 'visible'>) => void;
  remove: (id: string) => void;
  toggle: (id: string) => void;
}

let cid = 0;
export const useAiLayersStore = create<AiLayersStore>()(
  devtools(
    (set) => ({
      layers: [],
      add: (l) =>
        set((s) =>
          s.layers.some((x) => x.name === l.name) ? s : { layers: [...s.layers, { ...l, id: `ai-${++cid}`, visible: true }] },
        ),
      remove: (id) => set((s) => ({ layers: s.layers.filter((x) => x.id !== id) })),
      toggle: (id) =>
        set((s) => ({ layers: s.layers.map((x) => (x.id === id ? { ...x, visible: !x.visible } : x)) })),
    }),
    { name: 'aiLayers' },
  ),
);
